"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var RowContext_1 = require("./RowContext");
var Checkbox_1 = __importDefault(require("../Checkbox"));
var RenderRow = function (_a) {
    var skeleton = _a.skeleton, editMode = _a.editMode, massAction = _a.massAction, index = _a.index, rowsState = _a.rowsState, children = _a.children, onChangeRow = _a.onChangeRow, onEditMode = _a.onEditMode;
    var rowProps = React.useContext(RowContext_1.RowContext).rowProps;
    var _b = React.useState(false), isTouching = _b[0], setTouching = _b[1];
    var time = React.useRef();
    var classNameRow = (0, classnames_1.default)("nimbus--table-row", {
        "nimbus--table-row--grayed": rowProps.grayed,
        "nimbus--table-row--touching": isTouching,
    });
    var classNameRowCheck = (0, classnames_1.default)("nimbus--table-row__check", {
        "is--visible": editMode,
    });
    var handleTouchStart = function () {
        if (massAction) {
            setTouching(true);
            time.current = window.setTimeout(function () {
                if ("vibrate" in navigator) {
                    navigator.vibrate(10);
                }
                onEditMode === null || onEditMode === void 0 ? void 0 : onEditMode({ name: "".concat(index), checked: !rowsState[index] });
            }, 500);
        }
    };
    var handleCancelTouch = function () {
        clearTimeout(time.current);
        setTouching(false);
    };
    var handleClick = function (event) {
        var _a;
        event.stopPropagation();
        if (editMode) {
            onEditMode === null || onEditMode === void 0 ? void 0 : onEditMode({ name: "".concat(index), checked: !rowsState[index] });
        }
        else {
            (_a = rowProps.onClick) === null || _a === void 0 ? void 0 : _a.call(rowProps);
        }
    };
    return (React.createElement("tr", { onTouchStart: handleTouchStart, onTouchEnd: handleCancelTouch, onTouchMove: handleCancelTouch, onTouchCancel: handleCancelTouch, onClick: handleClick, className: classNameRow },
        massAction && (React.createElement("td", { className: classNameRowCheck }, skeleton ? (React.createElement(Checkbox_1.default.Skeleton, null)) : (React.createElement(Checkbox_1.default, { name: "".concat(index), checked: rowsState[index], onChange: onChangeRow })))),
        children));
};
exports.default = RenderRow;
//# sourceMappingURL=RenderRow.js.map